// src/pages/mission/components/DeployButton.jsx

import React from 'react';
import { ChevronRight } from 'lucide-react';
import { getColorClasses } from '../../themeConfig';

const DeployButton = ({ squad, alertColor, onDeploy }) => {
  return (
    <div className={`mt-8 bg-gray-800 border-2 ${getColorClasses(alertColor, 'alertBorder')} rounded-lg p-6`}>
      <div className="flex items-center justify-between">
        <div>
          <h3 className={`text-2xl font-bold ${getColorClasses(alertColor)}`}>READY TO DEPLOY</h3>
          <p className="text-gray-400">
            {squad.length} soldier{squad.length !== 1 ? 's' : ''} equipped and ready for combat
          </p>
        </div>
        <button
          onClick={onDeploy}
          className={`group relative ${getColorClasses(alertColor, 'bgMain')} ${getColorClasses(alertColor, 'bgHover')} text-white font-bold px-8 py-4 rounded-lg text-xl transition-all duration-300 transform hover:scale-105 shadow-lg ${getColorClasses(alertColor, 'shadow')} flex items-center gap-3`}
        >
          <span className="relative z-10">BEGIN MISSION</span>
          <ChevronRight size={28} className="relative z-10" />
          <div className={`absolute inset-0 ${getColorClasses(alertColor, 'bgMain')} rounded-lg blur opacity-50 group-hover:opacity-75 transition-opacity`} />
        </button>
      </div>
      <div className="mt-4 pt-4 border-t border-gray-700">
        <p className={`text-xs text-center ${getColorClasses(alertColor)} font-mono`}>
          ⚠️ WARNING: Mission cannot be aborted once combat begins. Casualties may occur.
        </p>
      </div>
    </div>
  );
};

export default DeployButton;